export class FormatacaoUtil{
    
      public static removerCaracteresEspeciais(nome?: string){
        if(nome !== undefined && nome !== '' && nome !== null) {
          const mapaAcentos = {
            'a': /[\xE0-\xE6]/gi,
            'e': /[\xE8-\xEB]/gi,
            'i': /[\xEC-\xEF]/gi,
            'o': /[\xF2-\xF6]/gi,
            'u': /[\xF9-\xFC]/gi,
            'c': /\xE7/gi,
            'n': /\xF1/gi
          };
          //remove acentos com base no mapa
          Object.entries(mapaAcentos).forEach(([letra, expressaoRegular]) => {
            nome = nome?.replace(expressaoRegular, letra);
          });
          
          //remove caracteres especiais
          nome = nome.replace(/[^\w\s]/gi, '');
          //substitui vários espaços em branco por apenas um
          nome = nome.replace(/\s+/g, ' ');
          //remove espaços em branco restantes no inicio e fim
          nome = nome.trim();
         return nome.toUpperCase();
        }
          return nome;
        }
}